import React from 'react';

interface MorafaaLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'light' | 'dark';
}

const MorafaaLogo: React.FC<MorafaaLogoProps> = ({ 
  className = '', 
  size = 'md',
  variant = 'light' 
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  // Use the appropriate logo based on size
  const getLogoSrc = () => {
    switch (size) {
      case 'sm':
        return '/favicon-32x32.png';
      case 'md':
        return '/android-chrome-192x192.png';
      case 'lg':
      case 'xl':
        return '/android-chrome-192x192.png';
      default:
        return '/android-chrome-192x192.png';
    }
  };

  return (
    <div className={`${sizeClasses[size]} ${className}`}>
      <img
        src={getLogoSrc()}
        alt="Morafaa Logo"
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default MorafaaLogo; 